// BlogList.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import './PublicBlog.css'
import './footer.css'
import { format } from 'date-fns';
import HomeIcon from '@mui/icons-material/Home';
import { Link } from "react-router-dom";
import Footer from "./footer";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";

const BlogList = () => {
    const [posts, setPosts] = useState([]);
    const [displayedPosts, setDisplayedPosts] = useState([]); // Posts to display
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [visibleCount, setVisibleCount] = useState(4); // Number of posts to display initially
    const [searchTerm, setSearchTerm] = useState(""); // State for search input


    const stripHtmlTags = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.innerText || div.textContent || "";
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return format(date, 'd MMM yyyy');
    };



    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get("https://kvch.in:859/api/posts"); // Adjust this endpoint if necessary
                const enabledPosts = response.data.filter(post => post.status === 'enabled');
                // Sort the enabled posts by created date
                const sortedPosts = enabledPosts.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
                setPosts(sortedPosts);
                setDisplayedPosts(sortedPosts.slice(0, visibleCount)); // Initially display the first set of posts
            } catch (err) {
                setError("Error fetching posts");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, [visibleCount]);

    const loadMorePosts = () => {
        setVisibleCount(prevCount => prevCount + 2); // Increase the count of visible posts by 6
        setDisplayedPosts(posts.slice(0, visibleCount + 4)); // Update displayed posts
    };



    const filteredTrendingPosts = posts
        .filter(post => post.title.toLowerCase().includes(searchTerm.toLowerCase()))
        .slice(0, 50); // Limit to 50 results

    // if (loading) return <div>Loading...</div>;
    if (loading) {
        return (
            <div id="preloader">
                <div id="loader"></div>
            </div>
        );
    }

    if (error) return <div>{error}</div>;

    return (
        <>
            <Helmet>
                <title>Latest Blog on Custom Web & Mobile Development | SISGAIN</title>
                <meta name="description" content="Stay ahead in digital transformation, web & mobile tech! Explore SISGAIN latest blog for insights, trends, and innovation. Read now!" />
                <link rel="icon" to="" type="image/x-icon" />
                <link rel="canonical" to="https://kvch.in/blogs" />
                <meta name="author" content="SISGAIN" />
                <meta name="og:title" content="Latest Blog on Custom Web & Mobile Development | SISGAIN" />
                <meta name='og:type' content="blogs" />
                <meta name="og:description" content="Stay ahead in digital transformation, web & mobile tech! Explore SISGAIN latest blog for insights, trends, and innovation. Read now!" />
                <meta name="og:url" content="https://kvch.in/blogs"/>
                <meta property="og:image" content="https://kvch.in/blogs/blog_og_image.webp" />
                <meta name="og:site_name" content="SISGAIN" />
                <meta name="distribution" content="global" />
                <meta name='subject' content="Blogs" />
                <meta name="rating" content="General" />
                <meta name="OWNER" type="email" value="hello@sisgain.ae" />
                <meta content="all" name="googlebot-Image" />
                <meta name="rating" content="5" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BlogPosting",
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": `https://kvch.in/blogs`,
                        },
                        "headline": "Latest Blog on Custom Web & Mobile Development | SISGAIN",
                        "description": "Stay ahead in digital transformation, web & mobile tech! Explore SISGAIN latest blog for insights, trends, and innovation. Read now!",
                        "image": "https://kvch.in/blogs/blog_og_image.webp",
                        "author": {
                            "@type": "Person",
                            "name": "SISGAIN",
                        },
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org/",
                        "@type": "WebSite",
                        "name": "SISGAIN",
                        "url": "https://kvch.in",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": `https://kvch.in/blogs/#{search_term_string}`,
                            "query-input": "required name=search_term_string"
                        }
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org/",
                        "@type": "BreadcrumbList",
                        "itemListElement": [{
                            "@type": "ListItem",
                            "position": 1,
                            "name": "Home",
                            "item": "https://kvch.in/"
                        }, {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Blogs",
                            "item": "https://kvch.in/blogs/#"
                        }]
                    })}
                </script>

            </Helmet>
            <Navbar />
            <section className="blog_banner">
                <div className="container">
                    <h1>Blogs</h1>
                    <span className="breadcrumbs">
                        <a href="https://kvch.in/"> <HomeIcon /> Home</a> /
                        <a href="https://kvch.in/blogs"> Blogs</a>
                    </span>
                </div>
            </section>

            <section className="blogList">
                <div className="container mt-4">


                    {posts.length === 0 ? (
                        <p>No posts available</p>
                    ) : (

                        <>


                            <div className="row">
                                <div className="col-lg-8">

                                    {displayedPosts.map((post) => (
                                        <Link to={`/blogs/${post.slug}`} target="blank">
                                            <div className="row  blogListBox">

                                                <div className="col-lg-6">
                                                    <div className="blogListImg">
                                                        <img src={`https://kvch.in:859${post.banner_image}`} alt={post.title} />
                                                    </div>

                                                    <div className="blog_author">
                                                        <div className="blog_author_i_n flex-fill d-inline-flex align-items-center">
                                                            <img src={`https://kvch.in:859${post.authorImg}`} alt={post.title} />
                                                            <span> {post.authorName}</span>
                                                        </div>
                                                        <div className="blog_date">
                                                            {formatDate(post.createdDate)} | <span>Read more</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <h2>{post.title}</h2>
                                                    <p>{stripHtmlTags(post.content)}</p>

                                                </div>

                                            </div>
                                        </Link>

                                    ))}


                                    {displayedPosts.length < posts.length && (
                                        <div style={{ textAlign: 'center', margin: '20px 0' }}>
                                            <button onClick={loadMorePosts} className="btn btn-primary">Load More</button>
                                        </div>
                                    )}
                                </div>
                                <div className="col-lg-4">
                                    <section className="trending_sec">

                                        <div class="form-group position-relative trending_search">
                                            <input
                                                type="search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="form-control rounded-pill"
                                                placeholder="Search By Keyword"
                                                required
                                            />
                                            <button type="submit" class="search-btn border-0 bg-transparent" aria-label="Search">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 36 36" fill="none">
                                                    <path d="M16.5 28.5C23.1274 28.5 28.5 23.1274 28.5 16.5C28.5 9.87258 23.1274 4.5 16.5 4.5C9.87258 4.5 4.5 9.87258 4.5 16.5C4.5 23.1274 9.87258 28.5 16.5 28.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M31.5 31.5L24.975 24.975" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </button>
                                        </div>

                                        <h3>Recent Posts</h3>
                                        <span className="footer_sep2"></span>
                                        <div className="filtered_posts">

                                            {filteredTrendingPosts.map((post) => (
                                                <div className="trending_div">
                                                       <a href={`/blogs/${post.slug}`} target="_blank">
                                                        <h4>{post.title}</h4>
                                                        <p>{stripHtmlTags(post.content)}</p>
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </section>
            <Footer />
        </>
    );
};

export default BlogList;

